<template>
  <v-navigation-drawer
    fixed
    permanent
    app
    disable-resize-watcher
    v-model="navDrawer.opened"
    :clipped="navDrawer.clipped"
    :floating="navDrawer.floating"
  >
    <template #prepend>
      <v-card flat link :to="{ name: 'page-index' }">
        <v-card-title class="title py-2">
          {{ $t('app.name') }}
        </v-card-title>
      </v-card>
    </template>
    <v-divider />
    <v-list dense v-if="$permissionsHandler(['READ_EVENT'])">
      <v-list-group dense v-if="eventCategories && eventCategories.length" no-action>
        <template #activator>
          <v-list-item :to="{ name: 'page-events' }" class="pl-0" dense>
            <v-list-item-content>
              <v-list-item-title>События</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item
          class="pl-8"
          dense
          v-for="categoryItem in eventList"
          :key="categoryItem.id"
          :to="
            categoryItem.slug !== 'events'
              ? {
                  name: 'page-events-by-category',
                  params: {
                    categorySlug: categoryItem.slug
                  }
                }
              : {
                  name: 'page-events'
                }
          "
          link
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ categoryItem.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <v-list-item
          v-if="$permissionsHandler(['READ_EVENTCATEGORY'])"
          class="pl-5"
          :to="{ name: 'page-categories' }"
          link
          dense
        >
          <v-list-item-content>
            <v-list-item-title>Категории событий</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$permissionsHandler(['READ_EVENTATTRIBUTEKEY'])"
          class="pl-5"
          :to="{ name: 'page-attributes' }"
          link
          dense
        >
          <v-list-item-content>
            <v-list-item-title>Атрибуты</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <v-divider />
    <v-list dense>
      <template v-for="(navItem, navItemIndex) in navItems">
        <v-list-item
          v-if="!navItem.children"
          :key="`${navItemIndex}-${navItemIndex}`"
          :dense="navItem.isDivider"
          :link="!navItem.isDivider"
          :ripple="navItem.to.name !== $route.name"
          :to="navItem.to.name === $route.name || navItem.isDivider ? null : navItem.to || null"
          :class="navItem.to.name === $route.name && !navItem.isDivider ? 'v-list-item--active' : ''"
        >
          <v-divider v-if="navItem.isDivider" />
          <v-list-item-content v-else>
            <v-list-item-title v-text="navItem.text" />
          </v-list-item-content>
        </v-list-item>
        <v-list-group v-else :key="`${navItemIndex}-${navItemIndex}`">
          <template #activator>
            <v-list-item :to="{ name: `page-${navItem.key}` }" class="pl-0" dense>
              <v-list-item-content>
                <v-list-item-title v-text="navItem.text" />
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item
            class="pl-8"
            dense
            v-for="childItem in navItem.children"
            :key="childItem.id"
            :link="!childItem.isDivider"
            :ripple="childItem.to.name !== $route.name"
            :to="childItem.to.name === $route.name || childItem.isDivider ? null : childItem.to || null"
            :class="childItem.to.name === $route.name && !childItem.isDivider ? 'v-list-item--active' : ''"
          >
          <v-list-item-content>
            <v-list-item-title v-text="childItem.text" />
          </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>
    <template #append>
      <v-list dense>
        <v-divider />
        <v-list-item class="py-2" v-if="false">
          <LanguagePopover />
        </v-list-item>
        <v-divider />
        <v-list-item @click="uiGeneral.darkTheme = !uiGeneral.darkTheme">
          <v-list-item-icon>
            <v-icon>mdi-theme-light-dark</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> Светлая/Темная тема </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logOut">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Выход</v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>
<script>
import { mapState } from 'vuex'
import { logOut } from '@/services/auth'
import navItems from '@/services/nav/nav-items.js'
import LanguagePopover from '@/components/language-popover'
import eventsCategoriesQuery from '@/services/gql/types/EventCategories/queries/eventCategories.gql'

export default {
  name: 'LayoutDefaultNavDrawer',
  components: {
    LanguagePopover
  },
  data () {
    return {
      eventCategories: []
    }
  },
  computed: {
    navDrawer () {
      return this.$deepModel('ui.navDrawer')
    },
    uiGeneral () {
      return this.$deepModel('ui.general')
    },
    navItems () {
      return navItems
        .filter(navItem => this.$permissionsHandler(navItem.permissions))
        .map(item => {
          if (item.to === null) { item.to = {} }
          if (item.children) {
            item.children
              .filter(navChild => this.$permissionsHandler(navChild.permissions))
              .map(navItem => {
                if (navItem.key) navItem.text = this.$t(`pages-name.children.${navItem.key}`)
                if (navItem.to === null) { navItem.to = {} }
                return navItem
              })
          }
          if (item.key) item.text = this.$t(`pages-name.parent.${item.key}`)
          return item
        })
    },
    eventList () {
      return [
        {
          id: 'EventAll',
          slug: 'events',
          title: 'Все события'
        },
        ...this.eventCategories
      ]
    },
    ...mapState('ui', ['navDrawer']),
    ...mapState('app', ['me'])
  },
  methods: {
    logOut
  },
  apollo: {
    eventCategories: {
      fetchPolicy: 'network-only',
      query: eventsCategoriesQuery,
      // pollInterval: 1000,
      variables: {
        where: {}
      },
      result ({ data }) {
        this.eventCategories = data?.eventCategories?.list
      }
    }
  }
}
</script>
